import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
export var LargeTitle = function (props) {
    var className = namespacedClassnames('title', 'large-title', props.className);
    return React.createElement("h2", { className: className }, props.children);
};
export var MediumTitle = function (props) {
    var className = namespacedClassnames('title', 'medium-title', props.className);
    return React.createElement("h3", { className: className }, props.children);
};
export var SmallTitle = function (props) {
    var className = namespacedClassnames('title', 'small-title', props.className);
    return React.createElement("h4", { className: className }, props.children);
};
//# sourceMappingURL=titles.js.map